import type { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import ActivityListItem from "@/pages/(app)/returns/view/components/return-activity/activity-list-item";

type ReturnRequestActivityListProps = {
	activities: ReturnRequestLogDto[];
	returnRequestId: string;
};

export default function ActivityList({
	activities,
	returnRequestId,
}: ReturnRequestActivityListProps) {
	const sortedActivities = activities.sort((a, b) =>
		a.date > b.date ? -1 : 1,
	);

	return (
		<div
			className={"relative flex flex-col gap-1"}
			id="return-request-activities"
		>
			<div className={"absolute left-3 top-0 bottom-2 w-[1px] bg-slate-200"} />
			{sortedActivities.map((activity) => {
				return (
					<ActivityListItem
						key={activity.id}
						activity={activity}
						returnRequestId={returnRequestId}
					/>
				);
			})}
		</div>
	);
}
